import { useCallback } from "react"
import { useAppDispatch } from "hooks/redux"
import { useDashboardId } from "../context/dashboard-id"
import { panelsSlice, type ModuleUpdates } from "../store/panels-slice"

/** Mirrors useAddModule/useRemoveModule — keeps callers free of dispatch boilerplate. */
export function useUpdateModule(): (moduleId: string, updates: ModuleUpdates) => void {
  const dispatch = useAppDispatch()
  const dashboardId = useDashboardId()

  return useCallback(
    (moduleId: string, updates: ModuleUpdates) => {
      dispatch(panelsSlice.actions.updateModule({ dashboardId, moduleId, updates }))
    },
    [dispatch, dashboardId],
  )
}
